import { put, takeEvery, call } from "redux-saga/effects";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

import * as actionTypes from "./constants";
import { appConfig } from "../../config";

function* commonFunction(value) {
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${value.api}`, {
      method: `${value.method}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: value.body ? value.body : null,
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: `${value.sucessAction}`,
        payload: resJSON,
      });
      if (value.extraAction) {
        yield put({
          type: `${value.extraAction}`,
          payload: resJSON,
        });
      }
    }
  } catch (err) {
    console.error("error", err);
    if (err.ok === false) {
      yield put({ type: `${value.failAction}`, error: err });
    } else {
    }
  }
}

function* fetchLoadMetrics(value) {
  try {
    let orgId = JSON.parse(localStorage.getItem("user")).orgId;
    let page = (value.payload && value.payload.page) || 1;
    let params = {
      page: page,
      api: `${appConfig.ip}/loadMetrics?orgId=${orgId}&limit=10&page=${page}&isActive=true`,
      method: "GET",
      sucessAction: actionTypes.LOAD_METRICS_SUCCESS_ACTION,
      failAction: actionTypes.LOAD_METRICS_FAIL_ACTION,
      body: null,
    };
    yield call(commonFunction, params);
  } catch (e) {
    console.error(e);
  }
}

function* fetchCargoSize(value) {
  try {
    let page = (value.payload && value.payload.page) || 1;
    let params = {
      page: page,
      api: `${appConfig.ip}/cargoSize?isActive=true`,
      method: "GET",
      sucessAction: actionTypes.CARGOSIZE_SUCCESS_ACTION,
      failAction: actionTypes.CARGOSIZE_FAIL_ACTION,
      body: null,
    };
    yield call(commonFunction, params);
  } catch (e) {
    console.error(e);
  }
}

function* addLoadMetrics(action) {
  try {
    let user = JSON.parse(localStorage.getItem("user"));
    const data = {
      orgId: user.orgId,
      userId: user.id,
      type: action.payload.type,
      noOfSmall: action.payload.noOfSmall,
      noOfMedium: action.payload.noOfMedium,
    };
    let params = {
      page: 0,
      api: `${appConfig.ip}/loadMetrics`,
      method: "POST",
      sucessAction: actionTypes.ADD_LOAD_METRICS_SUCCESS_ACTION,
      failAction: actionTypes.ADD_LOAD_METRICS_FAIL_ACTION,
      extraAction: actionTypes.LOAD_METRICS_INIT_ACTION,
      body: JSON.stringify(data),
    };
    yield call(commonFunction, params);
  } catch (e) {
    console.error(e);
  }
}

function* editLoadMetrics(action) {
  try {
    let user = JSON.parse(localStorage.getItem("user"));
    const data = {
      orgId: user.orgId,
      userId: user.id,
      type: action.params.type,
      noOfSmall: action.params.noOfSmall,
      noOfMedium: action.params.noOfMedium,
    };
    let params = {
      page: 0,
      api: `${appConfig.ip}/loadMetrics/` + action.id,
      method: "PUT",
      sucessAction: actionTypes.EDIT_LOAD_METRICS_SUCCESS_ACTION,
      failAction: actionTypes.EDIT_LOAD_METRICS_FAIL_ACTION,
      extraAction: actionTypes.LOAD_METRICS_INIT_ACTION,
      body: JSON.stringify(data),
    };
    yield call(commonFunction, params);
  } catch (e) {
    console.error(e);
  }
}

function* deleteLoadMetrics(action) {
  try {
    let user = JSON.parse(localStorage.getItem("user"));
    let id = action.data.id;
    let data = {
      isActive: false,
      deletedAt: new Date(),
    };
    let params = {
      page: 0,
      api: `${appConfig.ip}/loadMetrics/` + id,
      method: "PUT",
      sucessAction: actionTypes.EDIT_LOAD_METRICS_SUCCESS_ACTION,
      failAction: actionTypes.EDIT_LOAD_METRICS_FAIL_ACTION,
      extraAction: actionTypes.LOAD_METRICS_INIT_ACTION,
      body: JSON.stringify(data),
    };
    yield call(commonFunction, params);
  } catch (e) {
    console.error(e);
  }
}
export function* loadMetricsWatcher() {
  yield takeEvery(actionTypes.LOAD_METRICS_INIT_ACTION, fetchLoadMetrics);
  yield takeEvery(actionTypes.CARGOSIZE_INIT_ACTION, fetchCargoSize);
  yield takeEvery(actionTypes.ADD_LOAD_METRICS_INIT_ACTION, addLoadMetrics);
  yield takeEvery(actionTypes.EDIT_LOAD_METRICS_INIT_ACTION, editLoadMetrics);
  yield takeEvery(
    actionTypes.DELETE_LOAD_METRICS_INIT_ACTION,
    deleteLoadMetrics
  );
}
